export enum TipoPedidoAlerta {
    TudoCerto = 0,
    HaPedidosParcialmenteProcessados = 1
}
